import { useAuth } from '@/lib/auth/auth';
import { dashboardKeys } from '@/features/events/feed/feedQuery';
import type { DashboardResult } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export function useDashboard() {
  const session = useAuth((state) => state.session);
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: dashboardKeys.current(),
    enabled: Boolean(session),
    queryFn: () => request<DashboardResult>('/me/dashboard'),
  });
}
